
import React from "react";
import './Modal.css';
import { useState  } from "react";


function  Modal  ({setShowModal})  {
    return (
        <div  className="moal__wrapper"  >
            <div className="single__modal">

                <span  className="close__modal">
                    <i class="ri-close-line"  onClick={() => setShowModal(false)}></i>
                </span>


                <h6  className="text-center text-light "> place a Biad </h6>
                <p  className="text-center text-light "> You Must bid at least  <span  className="money"> 5.89ETH </span>  </p>

                <div className="input__item  mb-4">
                    <input type="number" placeholder="00:00 ETH" />
                </div>

                <div className="input__item  mb-4">
                    <h6> Enter Quantity , 7 available </h6>
                    <input type="number" placeholder=" Enter Quantity " />
                </div>

                <div  className=" d-flex align-items-center  justify-content-between " >
                    <p> You Must bid at least </p>
                    <span  className="money">  5.89ETH  </span>
                </div>

                <div  className=" d-flex align-items-center  justify-content-between" >
                    <p> Service Free </p>
                    <span  className="money">  0.89ETH  </span>
                </div>

                <div  className=" d-flex align-items-center  justify-content-between " >
                    <p> Total Bid Amount </p>
                    <span  className="money">  5.89ETH  </span>
                </div>

                <button  className="place__bid-btn">
                    place a Bid 
                </button>

            </div>

        </div>
    );
}

export default Modal;

